














































import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import { LeaversService } from '@/services/LeaversTool/LeaversService';
import { LeaverModel, LeaverStatus } from '@/types';
import { ArrayHelper } from '@/mixins/arrayHelper';
import { EnumHelper } from '@/mixins/enumHelper';
import { ProcessLeaver } from '@/mixins';

export default Vue.extend({
  name: 'ProcessLeaverHistory',
  mixins: [ProcessLeaver],
  data() {
    return {
      isLoading: false,
      pageIsLoading: false,
      configurationId: 0,
      statusId: -1,
      leavers: [] as LeaverModel[],
      fields: [
        {
          key: 'listItemValue',
          label: 'Leavers Unique ID',
          sortable: true
        },
        {
          key: 'listData',
          label: 'Details',
          sortable: true
        },
        {
          key: 'leavingDate',
          label: 'Leaving Date',
          formatter: 'date',
          sortable: true
        },
        {
          key: 'progressMessage',
          label: 'Progress'
        },
        {
          key: 'status',
          label: 'Status',
          formatter: (value: any) => {
            return LeaverStatus[value];
          },
          sortable: true
        },
        {
          key: 'errorMessage',
          label: 'Error Message'
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ]
    };
  },
  methods: {
    async getLeaversAsync(this: any) {
      this.isLoading = true;
      await LeaversService.getAllAsync().then((result: LeaverModel[]) => {
        this.leavers = result;
        if (result && result.length > 0) {
          this.configurationId = result[0].configuration.id;
        }
        this.isLoading = false;
      });
    }
  },
  computed: {
    configurationsDropdownOptions(this: any) {
      const leavers = this.leavers.map((leaver: LeaverModel) => ({
        id: leaver.configuration.id,
        description: this.getLeaverDescription(
          leaver.configuration.currentCabinet,
          leaver.configuration.destinationCabinet
        )
      }));

      return ArrayHelper.methods.removeDuplicates(leavers, 'id');
    },
    statusDropdownOptions(this: any) {
      const statuses = EnumHelper.methods.convertNumberBasedEnumToArray(LeaverStatus);
      statuses.push({ key: -1, value: 'All' });
      return statuses;
    },
    showLeavers(this: any): LeaverModel[] {
      let filteredLeavers = this.leavers.filter((x: LeaverModel) => x.configuration.id === this.configurationId);
      if (this.statusId > -1) {
        filteredLeavers = filteredLeavers.filter((x: LeaverModel) => x.status === this.statusId);
      }
      filteredLeavers.forEach((leaver: any) => {
        if (leaver.status === LeaverStatus.Pending) {
          leaver._cellVariants = { status: 'info' };
        } else if (leaver.status === LeaverStatus.Success) {
          leaver._cellVariants = { status: 'success' };
        } else if (leaver.status === LeaverStatus.Failed) {
          leaver._cellVariants = { status: 'danger' };
        }
      });
      return filteredLeavers;
    }
  },
  async mounted() {
    this.pageIsLoading = true;
    await this.getLeaversAsync();
    this.pageIsLoading = false;
  },
  components: {
    MStoreTable,
    MStoreFormSelect,
    LoadingSpinner
  }
});
